<template>
    <v-sheet>
        <h5 class="page-text--lg line-height-15 mb-8 mb-lg-16">
            학력사항
            <!-- <span v-if="mode == 'form'" class="page-text--sm grey-6--text pl-8 font-weight-regular">경력 작성시 더 좋은 일자리를 구할 수 있습니다.</span> -->
        </h5>

        <v-sheet>
            <v-divider class="primary border-2" />
            <vertical-table-row term="최종학력" :required="mode == 'form'">
                <template v-if="mode == 'form'">
                    <v-row align="center" class="row--small">
                        <v-col cols="12" md="4"> <v-select v-model="resume.education.institutionType" label="분류" :items="types" v-bind="attrs_input" :menuProps="{ attach: `.institutionType-${className}` }" :class="`institutionType-${className}`" @input="emit" /> </v-col>
                        <v-col cols="12" md="4"> <v-text-field v-model="resume.education.institutionName" label="학교" v-bind="attrs_input" @input="emit" /> </v-col>
                        <v-col cols="12" md="4"> <v-text-field v-model="resume.education.institutionDist" label="계열/학과" v-bind="attrs_input" @input="emit" /> </v-col>
                        <v-col cols="12" md="4"> <v-select v-model="resume.education.attendingStatus" label="상태" :items="statuses" :menuProps="{ attach: `.attendingStatus-${className}` }" :class="`attendingStatus-${className}`" v-bind="attrs_input" @input="emit" /> </v-col>
                        <v-col cols="12" md="4"> <v-date-field v-model="resume.education.attendingStartsAt" label="입학일" v-bind="attrs_input" @input="emit" /> </v-col>
                        <v-col cols="12" md="4"> <v-date-field v-model="resume.education.attendingEndsAt" label="졸업일" v-bind="attrs_input" @input="emit" /> </v-col>
                    </v-row>
                </template>
                <template v-else>
                    <v-row>
                        <v-col cols="12" class="white-space-pre"> {{ makeEducationText(resume.education) }} </v-col>
                    </v-row>
                </template>
            </vertical-table-row>

            <template v-for="(item, index) in resume.education.otherEducations">
                <vertical-table-row term="학력사항" :key="item.tempId">
                    <template v-if="mode == 'form'">
                        <v-row align="center">
                            <v-col>
                                <v-row class="row--small">
                                    <v-col cols="12" md="4"> <v-select v-model="item.institutionType" label="분류" :items="types" :menuProps="{ attach: `.institutionType-${className}-${index}` }" :class="`institutionType-${className}-${index}`" v-bind="attrs_input" @input="emit" /> </v-col>
                                    <v-col cols="12" md="4"> <v-text-field v-model="item.institutionName" label="학교" v-bind="attrs_input" @input="emit" /> </v-col>
                                    <v-col cols="12" md="4"> <v-text-field v-model="item.institutionDist" label="계열/학과" v-bind="attrs_input" @input="emit" /> </v-col>
                                    <v-col cols="12" md="4"> <v-select v-model="item.attendingStatus" label="상태" :items="statuses" :menuProps="{ attach: `.attendingStatus-${className}-${index}` }" :class="`attendingStatus-${className}-${index}`" v-bind="attrs_input" @input="emit" /> </v-col>
                                    <v-col cols="12" md="4"> <v-date-field v-model="item.attendingStartsAt" label="입학일" v-bind="attrs_input" @input="emit" /> </v-col>
                                    <v-col cols="12" md="4"> <v-date-field v-model="item.attendingEndsAt" label="졸업일" v-bind="attrs_input" @input="emit" /> </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="auto">
                                <v-btn icon x-small class="u-pink ml-auto ml-lg-0" @click="remove(item)"><i class="icon icon-minus" /></v-btn>
                            </v-col>
                            <!-- <v-col cols="12" lg="2"> <v-select v-model="item.institutionType" label="분류" :items="types" v-bind="attrs_input" @input="emit" /> </v-col>
                            <v-col cols="12" lg="3"> <v-text-field v-model="item.institutionName" label="학교" v-bind="attrs_input" @input="emit" /> </v-col>
                            <v-col cols="12" lg="3"> <v-text-field v-model="item.institutionDist" label="계열/학과" v-bind="attrs_input" @input="emit" /> </v-col>
                            <v-col lg="3" class="d-none d-lg-block">
                                <v-btn x-large text icon color="error" @click="remove(item)"> <v-icon>mdi-minus</v-icon> </v-btn>
                            </v-col>
                            <v-col cols="12" lg="2"> <v-select v-model="item.attendingStatus" label="상태" :items="statuses" v-bind="attrs_input" @input="emit" /> </v-col>
                            <v-col cols="12" lg="3"> <v-date-field v-model="item.attendingStartsAt" label="입학일" v-bind="attrs_input" @input="emit" /> </v-col>
                            <v-col cols="12" lg="3"> <v-date-field v-model="item.attendingEndsAt" label="졸업일" v-bind="attrs_input" @input="emit" /> </v-col>
                            <v-col cols="12" class="d-block d-lg-none">
                                <v-btn x-large text icon color="error" @click="remove(item)"> <v-icon>mdi-minus</v-icon> </v-btn>
                            </v-col> -->
                        </v-row>
                    </template>
                    <template v-else>
                        <v-row>
                            <v-col cols="12" lg="4">{{ makeEducationText(item) }} </v-col>
                        </v-row>
                    </template>
                </vertical-table-row>
            </template>
        </v-sheet>

        <template v-if="mode == 'form'">
            <v-btn block color="grey-f8" class="v-btn--plus rounded-lg" @click="addItem"> <i class="icon icon-plus-sm" /> </v-btn>
        </template>
    </v-sheet>
</template>

<script>
import dayjs from "dayjs";
import { attrs_input, EDUCATION_ATTENDING_STATUSES, EDUCATION_INSTITUTION_TYPES, initEducationItem, initResume } from "@/assets/variables";

import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import VerticalTableRow from "@/components/dumb/vertical-table-row.vue";

const types = Object.values(EDUCATION_INSTITUTION_TYPES);
const statuses = Object.values(EDUCATION_ATTENDING_STATUSES);

export default {
    components: {
        VDateField,
        VerticalTableRow,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // resume
        mode: { type: String, default: "form" },
    },
    data: () => ({
        resume: initResume(),

        types,
        statuses,
        attrs_input,
        className: Math.random().toString().slice(2),
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.resume = { ...initResume(), ...this.value };
        },
        emit() {
            let { education } = this.resume;
            this.$emit("input", { ...this.value, education });
        },
        addItem() {
            this.resume.education.otherEducations.push({ ...initEducationItem(), tempId: Math.random() });
            this.emit();
        },
        remove(item) {
            this.resume.education.otherEducations = this.resume.education.otherEducations.filter(({ tempId }) => tempId != item.tempId);
            this.emit();
        },
        makeEducationText({ institutionName, institutionDist, institutionType, attendingStatus, attendingStartsAt, attendingEndsAt } = {}) {
            let text = "";
            text += [institutionName, institutionDist].filter((item) => item).join(" / ");

            let state = [EDUCATION_INSTITUTION_TYPES[institutionType]?.text, EDUCATION_ATTENDING_STATUSES[attendingStatus]?.text].filter((item) => item).join(" ");
            let dates = [attendingStartsAt, attendingEndsAt]
                .filter((item) => item)
                .map((item) => dayjs(item).format("YYYY.MM.DD"))
                .join(" ~ ");

            if (state || dates) text += "\n";
            if (state) text += `${state} `;
            if (dates) text += `(${dates})`;

            return text.trim();
        },
    },
};
</script>


<style lang="scss" scoped>
.row--small {
    margin: -5px -2px;
    > [class*="col"] {
        padding: 5px 2px;
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .row--small {
        margin: -5px;
        > [class*="col"] {
            padding: 5px;
        }
    }
}
@media (min-width: 1200px) {
}
</style>